var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 16.5H7.35C9.75 16.5 11.25 15 11.25 12.6V9.5625H6.5625C6.255 9.5625 6 9.3075 6 9C6 8.6925 6.255 8.4375 6.5625 8.4375H11.25L11.25 5.4C11.25 3 9.75 1.5 7.35 1.5H5.4075C3.0075 1.5 1.5075 3 1.5075 5.4L1.5075 12.6C1.5 15 3 16.5 5.4 16.5Z",
    fill: "#677481"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5799 9.5625L13.0274 11.115C12.9149 11.2275 12.8624 11.37 12.8624 11.5125C12.8624 11.655 12.9149 11.805 13.0274 11.91C13.2449 12.1275 13.6049 12.1275 13.8224 11.91L16.3349 9.3975C16.5524 9.18 16.5524 8.82 16.3349 8.6025L13.8224 6.09C13.6049 5.8725 13.2449 5.8725 13.0274 6.09C12.8099 6.3075 12.8099 6.6675 13.0274 6.885L14.5799 8.4375H11.2499V9.5625H14.5799Z",
    fill: "#677481"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.da8b5a09c8f64139f40ae0d94fa71744.svg";
export { ForwardRef as ReactComponent };